import {
  TAXIS,
  EQUIPEMENT,
  HOME,
  BADGES,
  TRIPS,
  BOOKINGS,
  BILLS,
  DRIVER_TAXIS,
  DRIVERS,
  MAP,
  STATISTICS,
  RECETTE,
  COURSES_TRIPS
} from "Constant";

import {
  IconCar,
  IconFileInvoice,
  IconHome,
  IconIdBadge2,
  IconPigMoney,
  IconTimelineEventText,
  IconTipJarPound,
  IconTools,
  IconUsersGroup,
  IconChartBar,
  IconCash,
} from "@tabler/icons-react";

import { shouldAllowBookings } from "utils/domain";


export const ABOUT = {
  menutitle: DRIVER_TAXIS,
  Items: [
    {
      path: "/home",
      icon: IconHome,
      type: "link",
      title: MAP,
    },
    {
      path: "/users",
      icon: IconUsersGroup,
      type: "link",
      title: DRIVERS,
    },
    {
      path: "/taxis",
      icon: IconCar,
      type: "link",
      title: TAXIS,
    },
  ],
};

const DRIVERS_AXIS_MENU = {
  menutitle: TRIPS,
  Items: [
    {
      path: "/trips",
      icon: IconTipJarPound,
      type: "link",
      title: TRIPS,
    },
    ...(shouldAllowBookings() ? [{
      path: "/bookings",
      icon: IconTimelineEventText,
      type: "link",
      title: BOOKINGS,
    }] : []),
    {
      path: "/invoices",
      icon: IconFileInvoice,
      type: "link",
      title: BILLS,
    },
  ],
};

const EQUIPEMENTS_MENU = {
  menutitle: EQUIPEMENT,
  Items: [
    {
      path: "/badges",
      icon: IconIdBadge2,
      type: "link",
      title: BADGES,
    },
    {
      path: "/equipements",
      icon: IconTools,
      type: "link",
      title: EQUIPEMENT,
    },
  ],
};

const STATISTICS_MENU = {
  menutitle: STATISTICS,
  Items: [
    {
      path: "/statistics/trips",
      icon: IconChartBar,
      type: "link",
      title: COURSES_TRIPS,
    },
    {
      path: "/statistics/recette",
      icon: IconCash,
      type: "link",
      title: RECETTE,
    },
  ],
};
export const MENU_ITEMS = [ABOUT, DRIVERS_AXIS_MENU, EQUIPEMENTS_MENU,STATISTICS_MENU];
